export const API_URL = process.env.REACT_APP_API_URL;
export const WEB_VERSION = process.env.REACT_WEB_VERSION;
